
const DotsSpinner = () => {
    return (
        <div className="flex space-x-2 animate-pulse">
            <div className={`w-2 h-2 bg-primary rounded-full`} />
            <div className={`w-2 h-2 bg-primary rounded-full`} />
            <div className={`w-2 h-2 bg-primary rounded-full`} />
        </div>
    )
}

export default DotsSpinner